import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface StoreSliceModel {
   store: {
        [key:string]: []
   }
}

const initialState:StoreSliceModel = {
    store: {}
}

export const storeSlice = createSlice({
    name: "store",
    initialState: initialState,
    reducers: {
        setStore: (state, action: PayloadAction<{data:[], key: string}>) => {
            state.store[action.payload.key] =  action.payload.data
        },
        clearStore: (state) => {
            state.store ={};
        },
    }
})

export const { setStore,clearStore } = storeSlice.actions;

export default storeSlice.reducer;
